export function asc(a, b) {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}
export function desc(a, b) {
    return asc(b, a);
}
export function ascBool(a, b) {
    if (a && !b) {
        return 1;
    }
    if (b && !a) {
        return -1;
    }
    return 0;
}
export function descBool(a, b) {
    return ascBool(b, a);
}
export function ascStr(a, b) {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}
//# sourceMappingURL=universal_compare_helper.js.map